/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductRegisterReqVo } from './ProductRegisterReqVo';
import {
    ProductRegisterReqVoFromJSON,
    ProductRegisterReqVoFromJSONTyped,
    ProductRegisterReqVoToJSON,
    ProductRegisterReqVoToJSONTyped,
} from './ProductRegisterReqVo';

/**
 * 
 * @export
 * @interface EcommerceProductImportPageVo
 */
export interface EcommerceProductImportPageVo {
    /**
     * SPU 草稿列表，字段同商品注册 ProductRegisterReqVO
     * SPU草稿列表，结构同商品注册请求
     * @type {Array<ProductRegisterReqVo>}
     * @memberof EcommerceProductImportPageVo
     */
    records?: Array<ProductRegisterReqVo>;
    /**
     * 下一页游标
     * @type {string}
     * @memberof EcommerceProductImportPageVo
     */
    nextToken?: string;
    /**
     * 是否还有下一页
     * @type {boolean}
     * @memberof EcommerceProductImportPageVo
     */
    hasNext?: boolean;
}

/**
 * Check if a given object implements the EcommerceProductImportPageVo interface.
 */
export function instanceOfEcommerceProductImportPageVo(value: object): value is EcommerceProductImportPageVo {
    return true;
}

export function EcommerceProductImportPageVoFromJSON(json: any): EcommerceProductImportPageVo {
    return EcommerceProductImportPageVoFromJSONTyped(json, false);
}

export function EcommerceProductImportPageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcommerceProductImportPageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(ProductRegisterReqVoFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'hasNext': json['hasNext'] == null ? undefined : json['hasNext'],
    };
}

export function EcommerceProductImportPageVoToJSON(json: any): EcommerceProductImportPageVo {
    return EcommerceProductImportPageVoToJSONTyped(json, false);
}

export function EcommerceProductImportPageVoToJSONTyped(value?: EcommerceProductImportPageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(ProductRegisterReqVoToJSON)),
        'nextToken': value['nextToken'],
        'hasNext': value['hasNext'],
    };
}

